import BaseAPIService from '../base/base-api-service';
import ProductDetailsModel from 'src/model/productdetails.model';
import ProductModel from 'src/model/product.model';
import ProductManufacturer from 'src/model/productManufacturer.model';

class ProductService extends BaseAPIService<ProductDetailsModel> {
  public endpoint: string = '/navapp/v1/product';

  constructor() {
    super(ProductDetailsModel);
  }

  public getProductDetails(
    partNumber: string,
    mfc?: string
  ): Promise<ProductDetailsModel> {
    let opts = {};
    const params: any = {};
    if (mfc) {
      params.mfc = mfc;
    }
    opts = {
      'Content-Type': 'application/json'
    };
    // console.log('escape', escape(partNumber));
    // console.log('encodeURI', encodeURI(partNumber));
    // console.log('encodeURIComponent', encodeURIComponent(partNumber));
    const regExp = /\(([^)]+)\)/;
    const part = regExp.exec(partNumber)
      ? escape(partNumber)
      : encodeURIComponent(partNumber);
    console.log('part', part);
    return this.getOneByParams(`${this.endpoint}/detail/${part}`, params, opts);
  }

  public getProductManufacturers(
    partNumber: string
  ): Promise<ProductManufacturer[]> {
    const regExp = /\(([^)]+)\)/;
    const part = regExp.exec(partNumber)
      ? escape(partNumber)
      : encodeURIComponent(partNumber);
    return this.doRequest({
      baseURL: this.baseURL,
      method: 'GET',
      url: `${this.endpoint}/${part}/manufacturers`
    }).then(res => {
      return ProductManufacturer.castArray<ProductManufacturer>(
        res.data,
        ProductManufacturer
      );
    });
  }

  public getProductsSearch(products: any[]): Promise<ProductModel[]> {
    return this.doRequest({
      baseURL: this.baseURL,
      method: 'POST',
      data: { products },
      url: `${this.endpoint}/search`
    }).then(res => {
      return ProductModel.castArray<ProductModel>(res.data, ProductModel);
    });
  }
}

const productServiceInstance = new ProductService();
Object.freeze(productServiceInstance);

export default productServiceInstance;
